/**
 * Modèle CANONIQUE et UNIQUE du cycle de vie (idée → publication). Source de vérité
 * partagée (LifecycleRail, guidage persistant, onboarding) pour en finir avec les
 * dépictions divergentes du flux. L'APPROBATION est une PORTE entre étapes, pas une
 * étape : elle se répète (cadrage, options, spec) et n'apparaît donc pas comme un nœud.
 */
import {
  Lightbulb, Compass, GitCompareArrows, FileText, Columns3, Code2, Rocket,
  type LucideIcon,
} from 'lucide-react'

export type LifecycleStep =
  | 'idee' | 'cadrage' | 'options' | 'spec' | 'backlog' | 'code' | 'publication'

export interface LifecycleStage {
  key: LifecycleStep
  /** Libellé FR par défaut (repli i18n de la clé `lifecycleRail.<key>`). */
  label: string
  /** Route où l'on agit sur cette étape. */
  to: string
  icon: LucideIcon
}

export const LIFECYCLE: LifecycleStage[] = [
  { key: 'idee', label: 'Idée', to: '/ideas', icon: Lightbulb },
  { key: 'cadrage', label: 'Cadrage', to: '/approvals', icon: Compass },
  { key: 'options', label: 'Options', to: '/approvals', icon: GitCompareArrows },
  { key: 'spec', label: 'Spécification', to: '/approvals', icon: FileText },
  { key: 'backlog', label: 'Backlog', to: '/backlog', icon: Columns3 },
  { key: 'code', label: 'Code', to: '/backlog', icon: Code2 },
  { key: 'publication', label: 'Publication', to: '/pipelines', icon: Rocket },
]

/**
 * Résout l'étape courante à partir d'un chemin (pour le rail de flux persistant).
 * Renvoie null hors des routes de flux — le rail ne s'affiche alors pas.
 */
export function lifecycleStepFromPath(pathname: string): LifecycleStep | null {
  if (pathname.startsWith('/ideas')) return 'idee'
  if (pathname.startsWith('/approvals')) return 'spec'
  if (pathname.startsWith('/editor')) return 'spec'
  if (pathname.startsWith('/backlog')) return 'backlog'
  if (pathname.startsWith('/tree')) return 'backlog'
  if (pathname.startsWith('/graph')) return 'backlog'
  if (pathname.startsWith('/pipelines')) return 'publication'
  return null
}
